import { useEffect, useRef } from 'react'
import { useClientContext, usePlayerContext } from '../../../hooks'
import { TRANSITION_TIME, transitionTemplate } from '../../../constants/constants'
import { AnimatePresence, motion } from 'framer-motion'

export const QuizAnswer = (props) => {
  const {
    answerId,
    index,
    backgroundObject: background,
    controlViewData,
    extraControlViewData,
    isHighlighted,
    textData,
    imageData,
    inputType,
    isChecked,
    isCheckbox,
    onAnswerChooseHandler,
    getElementStyles,
    container,
  } = props

  const { playerBounding } = usePlayerContext()
  const { isFullScreen } = useClientContext()

  const labelRef = useRef(null)
  const controlRef = useRef(null)

  const template = {
    ...transitionTemplate,
    transition: { duration: TRANSITION_TIME + index, delay: index * 0.2 },
  }

  const correctedBounding = { ...playerBounding, x: 0, y: isFullScreen ? 0 : playerBounding.top }

  useEffect(() => {
    if (isHighlighted) labelRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [isHighlighted])

  // force update of checkbox state if isChecked changed outside component. State may be changed while keyboard navigation
  useEffect(() => {
    if (!controlRef.current) return
    controlRef.current.checked = isChecked
  }, [isChecked])

  return (
    <AnimatePresence>
      <motion.label
        ref={labelRef}
        {...template}
        style={getElementStyles(
          correctedBounding,
          { ...background, isHighlighted, isImageBased: !!imageData, isChecked },
          container,
        )}
        className={`quiz-answer${isChecked ? ' quiz-answer-checked' : ''}`}
        key={background.id}
      >
        <input
          onInput={onAnswerChooseHandler}
          name={isCheckbox ? answerId : 'answer-group'}
          ref={controlRef}
          type={inputType}
          value={answerId}
          className="sr-only answer-control-native"
        />
        {textData && <span className="sr-only">{textData.text}</span>}
        {imageData && <img src={imageData.src} alt={textData?.text} className="sr-only" />}
      </motion.label>
      <motion.span
        {...template}
        className={`answer-control${isChecked ? ' answer-control-checked' : ''}${imageData ? ' answer-control-image-based' : ''}`}
        style={getElementStyles(correctedBounding, controlViewData, container)}
        key={controlViewData.id}
      ></motion.span>
      {imageData && (
        <motion.span
          {...template}
          className={`answer-image${isChecked ? ' answer-control-checked' : ''}`}
          style={getElementStyles(correctedBounding, imageData, container)}
          key={imageData.id}
        ></motion.span>
      )}
      {extraControlViewData && (
        <motion.span
          {...template}
          className={`answer-control${isHighlighted || isChecked ? '' : ' answer-control-no-opacity'}`}
          style={getElementStyles(correctedBounding, extraControlViewData, container)}
          key={extraControlViewData.id}
        ></motion.span>
      )}
      {textData && (
        <motion.span
          {...template}
          className={`answer-text${isChecked ? ' answer-text-checked' : ''}`}
          style={getElementStyles(correctedBounding, textData, container)}
          key={textData.id}
        ></motion.span>
      )}
    </AnimatePresence>
  )
}
